<template>
  <div
    class="about-us"
    :class="{
      desktop: isDesktop,
      mobile: isMobile,
    }"
  >
    <div class="header-content">
      <h2 class="sub-title" v-if="isMobile">
        簡訊預約，快速方便免註冊<br />讓預約無所不在<br />讓客人自動進來
      </h2>
      <h1 class="title">
        一搜尋立即約<br />
        讓每筆搜尋都變成收入
      </h1>
      <h2 class="sub-title" v-if="isDesktop">
        簡訊預約，快速方便免註冊<br />讓預約無所不在，讓客人自動進來
      </h2>
      <a
        href="https://ohbottech.com/request-gmb-service"
        target="_blank"
        rel="noopener noreferrer"
      >
        <button>0元方案免費試用</button>
      </a>
    </div>
  </div>
</template>

<script setup>
import { useWindowSize } from '@vueuse/core'
import { computed } from '@vue/reactivity'
import { toForm } from '@/utils/helper'
const { width } = useWindowSize()

const isDesktop = computed(() => {
  return width.value > 768
})
const isMobile = computed(() => {
  return width.value < 768
})
</script>

<style scoped lang="postcss">
.about-us {
  @apply h-[611px] w-full;
}

.desktop {
  background-image: url('@/assets/header/sms-reservation.png');
}

.mobile {
  @apply h-[408px];
  background-image: url('@/assets/header/mobile/sms-reservation.png');
}

.header-content {
  @apply text-left text-primary-100 px-[136px] pt-[120px];
  @apply <ipad:(px-[20px] );
  @apply <tablet:(px-[30px] pt-[200px]);
}

button {
  @apply bg-secondary-100 text-white rounded-full;
  @apply px-[68px] py-[15px] leading-[23.17px];
  @apply <ipad:(px-[20px] py-[6px] text-[16px]);
  @apply <tablet:(px-[20px] py-[6px] text-[16px]);
}

.title {
  @apply m-0 font-bold text-[60px] leading-[86.88px] tracking-[2px] mb-[25px];
  @apply <ipad:(text-[30px]);
  @apply <tablet:(text-[26px] mb-[20px]);
}

.sub-title {
  @apply font-medium text-[27.16px] leading-[40px] tracking-[1.51px] mb-[42px];
  @apply <ipad:(text-[16px] leading-[1.3]);
  @apply <tablet:(text-[12px] mb-[20px] leading-[1.3]);
}
</style>
